{
  "Seguimiento del pedido": "Order tracking",
  "Enviado": "Shipped",
  "Empaquetado": "Packed",
  "Recibido": "Received",
  "Items del pedido": "Order items",
  "En proceso": "Processing",
  "Devolución solicitada": "Return requested",
  "Devolución en proceso": "Return in progress",
  "Devuelto": "Returned",
  "Envío": "Shipment",
  "Devolución": "Return",
  "Ver en tienda": "View in store",
  "Solicitudes de devolución": "Return requests",
  "Envíos": "Shipments",
  "Confirmado": "Confirmed",
  "En curso": "In progress",
  "Seguimiento de envío": "Shipment tracking",
  "Destino": "Destination",
  "Dirección destino": "Destination address",
  "Última actualización": "Last update",
  "Devolución pendiente": "Return pending",
  "Recogida solicitada": "Pickup requested",
  "Devolución enviada": "Return shipped",
  "Entrega estimada": "Estimated delivery",
  "Valora tu experiencia con nosotros": "Rate your experience with us",
  "¡Gracias!": "Thank you!",
  "Mensaje de alerta": "Alert message",
  "Punto de recogida": "Pickup point",
  "Mostrar historial completo": "Show complete history",
  "Ocultar historial": "Hide history",
  "¿Necesitas hacer una devolución o cambio?": "Need to return or exchange something?",
  "¿Quieres devolver algo más?": "Want to return something else?",
  "Devuelve o cambia tu artículo en pocos pasos.": "Return or exchange your item in a few easy steps.",
  "Empieza el proceso en pocos pasos. Te guiaremos durante todo el proceso.": "Start a return or exchange in just a few steps. We'll guide you through the process.",
  "Abrir el portal de devoluciones": "Open the returns portal",
  "Enviando": "Sending",
  "¡Página no encontrada!": "Page not found!",
  "Lo sentimos, pero no se pudo encontrar la página que estabas buscando": "Sorry, the page you were looking for could not be found",
  "Puedes volver al ": "You can go back to the ",
  "principio": "start",
  "o escribirnos a support@reveni.io si no encuentras lo que estabas buscando": "or write to us at support@reveni.io if you cannot find what you were looking for"
}
